export const Themes = {
  THEME_1: 'theme1',
  THEME_2: 'theme2',
  THEME_3: 'theme3',
};
